import {useEffect, useState, useRef} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Form from "react-bootstrap/Form";
import Offcanvas from "react-bootstrap/Offcanvas";

import {SwalAlertClass} from "core/swalClass";
import ValuePreviewInline from "components/ValuePreviewInline";
import ValuePreview from "components/ValuePreview";
import {NetworkConfigDetails} from "site-apps/devices/networks/NetworksConfigsModels";
import axiApi from "ApiCaller";
import FormButton from "components/buttons/FormButton";
import useCustomTranslation from "core/customTranslation";
import {publishEvent} from "core/eventsConnector";
import translations from "./translations";

const CarriesDefault = function () {
    return {server_carry: false, mqtt_carry: false, ntp_carry: false, gps_carry: false};
};

const FormSender = ({item, items, showCanvas, setShowCanvas, setItemsShown}) => {
    const {t: _TC} = useCustomTranslation(translations);
    const Alert = new SwalAlertClass({confirmButtonText: _TC("button.accept")});
    const configs = useRef([]);
    const [configsShow, setConfigsShow] = useState([]);
    const [config, setConfig] = useState({...NetworkConfigDetails});
    const [carries, setCarries] = useState(new CarriesDefault());
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!configs.current.length) {
            axiApi
                .get("/api/devices/networks/details/")
                .then((r) => {
                    configs.current = r.data.items;
                    setConfigsShow(r.data.items);
                    setConfigByItem();
                })
                .catch((error) => {
                    console.error("[FormMode] Error al obtener las configuraciones");
                    console.error(error);
                    Alert.error(_TC("message.error.title"), _TC("message.error.configs"));
                });
        } else {
            setConfigByItem();
        }
    }, []);

    const handleClose = () => setShowCanvas(false);

    const clickCancel = () => {
        setShowCanvas(false);
    };

    const onChangeCarry = (e) => {
        const {name, checked} = e.target;
        let carry = {...carries};
        carry[name] = checked;
        setCarries(carry);
    };

    const onChangeConfig = (e) => {
        let id = parseInt(e.target.value);
        if (id) {
            let chose = configs.current.find((item) => item.id === id);
            if (chose) {
                setConfig({...chose});
                let carry_ = {
                    server_carry: Boolean(chose.server),
                    mqtt_carry: Boolean(chose.mqtts && chose.mqtts.length > 0),
                    ntp_carry: Boolean(chose.ntp),
                    gps_carry: Boolean(chose.gps),
                };
                setCarries(carry_);
                return false;
            }
        }
        setConfig({...NetworkConfigDetails});
    };

    const onSubmit = (e) => {
        setIsLoading(true);
        e.preventDefault();
        if (!config.id) {
            Alert.warning(_TC("message.warning.title"), _TC("message.no.config.selected"));
            return false;
        }

        let datasend = {
            config: config.id,
            items: items.current.items.map((item) => item.uuid),
            server_carry: carries.server_carry,
            mqtt_carry: carries.mqtt_carry,
            ntp_carry: carries.ntp_carry,
            gps_carry: carries.gps_carry,
        };

        axiApi
            .patch("/api/devices/networks/send/", datasend)
            .then((r) => {
                if (r.data.status) {
                    setShowCanvas(false);
                    Alert.success(_TC("message.success.title"), _TC("message.success.saved")).then(() => {
                        publishEvent("reload:view:sender", {});
                    });
                    setIsLoading(false);
                } else {
                    Alert.error(_TC("message.error.service"), _TC("message.error.admin"));
                    setIsLoading(false);
                }
            })
            .finally(() => setIsLoading(false));
    };
    const setConfigByItem = () => {
        let carry = {
            server_carry: item.server_carry,
            mqtt_carry: item.mqtt_carry,
            ntp_carry: item.ntp_carry,
            gps_carry: item.gps_carry,
        };
        setCarries(carry);
        if (item.config_id && configs.current.length) {
            let chosen = configs.current.find((conf) => conf.id === item.config_id);
            if (chosen) {
                setConfig({...chosen});
                return false;
            }
        }
        setConfig({...NetworkConfigDetails});
    };

    return (
        <>
            <Offcanvas
                show={showCanvas}
                onHide={handleClose}
                placement="end"
                backdrop="false"
                aria-modal={true}
                style={{width: "50%"}}>
                <Offcanvas.Header className="preview-canvas" closeButton>
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="fa-solid fa-wrench" />
                    </div>
                    <div className="preview-title">
                        <Offcanvas.Title>{_TC("form.title.select.config")}</Offcanvas.Title>
                    </div>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <h4 className="text-center">
                        <span className="text-black-50">{_TC("label.uuid")}:</span> {item.uuid}
                    </h4>
                    <Form onSubmit={onSubmit} className="p-2">
                        <div className="preview-item">
                            <label>{_TC("label.profile.group")}</label>
                            <Form.Select className="mb-2" id="model" name="model" value={config.id} onChange={onChangeConfig}>
                                <option value="0">{_TC("option.select.config")}</option>
                                {configsShow.map((conf, index) => (
                                    <option key={index} value={conf.id}>
                                        {conf.name}
                                    </option>
                                ))}
                            </Form.Select>
                        </div>
                        {config.id ? (
                            <>
                                <ValuePreviewInline label={_TC("label.model")} value={config.model} />
                                <ValuePreview label={_TC("label.name")} value={config.name} />
                                <ValuePreview label={_TC("label.description")} value={config.description} />
                                <hr className="col-12 mt-5" />
                                {config.server && (
                                    <>
                                        <div className="col-12 d-flex justify-content-between">
                                            <h5>{_TC("label.network")}</h5>
                                            <div className="form-check">
                                                <label className="form-check-label" htmlFor="server_carry">
                                                    {_TC("label.send")}
                                                </label>
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="server_carry"
                                                    checked={carries.server_carry}
                                                    name="server_carry"
                                                    onChange={onChangeCarry}
                                                />
                                            </div>
                                        </div>
                                        <ValuePreview label={_TC("label.name")} value={config.server.name} />
                                        {Object.keys(config.server.values).map((key, index) => {
                                            if (`has_${key}` in config.server.has) {
                                                if (config.server.has[`has_${key}`]) {
                                                    return (
                                                        <ValuePreviewInline
                                                            key={index}
                                                            label={_TC("label." + key)}
                                                            value={config.server.values[key]}
                                                        />
                                                    );
                                                }
                                            } else {
                                                return (
                                                    <ValuePreviewInline
                                                        key={index}
                                                        label={_TC("label." + key)}
                                                        value={config.server.values[key]}
                                                    />
                                                );
                                            }
                                            return <></>;
                                        })}

                                        <hr className="col-12 mt-5" />
                                    </>
                                )}
                                {config.mqtts && config.mqtts.length > 0 && (
                                    <>
                                        <div className="col-12 d-flex justify-content-between">
                                            <h5>MQTT</h5>
                                            <div className="form-check">
                                                <label className="form-check-label" htmlFor="mqtt_carry">
                                                    {_TC("label.send")}
                                                </label>
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="mqtt_carry"
                                                    checked={carries.mqtt_carry}
                                                    name="mqtt_carry"
                                                    onChange={onChangeCarry}
                                                />
                                            </div>
                                        </div>
                                        {config.mqtts.map((mqtt, index) => (
                                            <div key={index} className="col-12">
                                                <ValuePreview label={_TC("label.name")} value={mqtt.name} />
                                                {Object.keys(mqtt.values).map((key, index) => {
                                                    if (`has_${key}` in mqtt.has) {
                                                        if (mqtt.has[`has_${key}`]) {
                                                            return (
                                                                <ValuePreviewInline
                                                                    key={index}
                                                                    label={_TC("label." + key)}
                                                                    value={mqtt.values[key]}
                                                                />
                                                            );
                                                        }
                                                    } else {
                                                        return (
                                                            <ValuePreviewInline
                                                                key={index}
                                                                label={_TC("label." + key)}
                                                                value={mqtt.values[key]}
                                                            />
                                                        );
                                                    }
                                                    return <></>;
                                                })}
                                            </div>
                                        ))}
                                        <hr className="col-12 mt-5" />
                                    </>
                                )}
                                {config.ntp && (
                                    <>
                                        <div className="col-12 d-flex justify-content-between">
                                            <h5>NTP</h5>
                                            <div className="form-check">
                                                <label className="form-check-label" htmlFor="ntp_carry">
                                                    {_TC("label.send")}
                                                </label>
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="ntp_carry"
                                                    checked={carries.ntp_carry}
                                                    name="ntp_carry"
                                                    onChange={onChangeCarry}
                                                />
                                            </div>
                                        </div>
                                        <ValuePreview label={_TC("label.name")} value={config.ntp.name} />
                                        {Object.keys(config.ntp.values).map((key, index) => {
                                            if (`has_${key}` in config.ntp.has) {
                                                if (config.ntp.has[`has_${key}`]) {
                                                    return (
                                                        <ValuePreviewInline
                                                            key={index}
                                                            label={_TC("label." + key)}
                                                            value={config.ntp.values[key]}
                                                        />
                                                    );
                                                }
                                            } else {
                                                return (
                                                    <ValuePreviewInline
                                                        key={index}
                                                        label={_TC("label." + key)}
                                                        value={config.ntp.values[key]}
                                                    />
                                                );
                                            }
                                            return <></>;
                                        })}
                                        <hr className="col-12 mt-5" />
                                    </>
                                )}
                                {config.gps && (
                                    <>
                                        <div className="col-12 d-flex justify-content-between">
                                            <h5>GPS</h5>
                                            <div className="form-check">
                                                <label className="form-check-label" htmlFor="gps_carry">
                                                    {_TC("label.send")}
                                                </label>
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="gps_carry"
                                                    checked={carries.gps_carry}
                                                    name="gps_carry"
                                                    onChange={onChangeCarry}
                                                />
                                            </div>
                                        </div>
                                        <ValuePreview label={_TC("label.name")} value={config.gps.name} />
                                        {Object.keys(config.gps.values).map((key, index) => {
                                            if (`has_${key}` in config.gps.has) {
                                                if (config.gps.has[`has_${key}`]) {
                                                    return (
                                                        <ValuePreviewInline
                                                            key={index}
                                                            label={_TC("label." + key)}
                                                            value={config.gps.values[key]}
                                                        />
                                                    );
                                                }
                                            } else {
                                                return (
                                                    <ValuePreviewInline
                                                        key={index}
                                                        label={_TC("label." + key)}
                                                        value={config.gps.values[key]}
                                                    />
                                                );
                                            }
                                            return <></>;
                                        })}
                                    </>
                                )}

                                <div className="text-end col-12 mb-4 mt-4">
                                    <button type="button" className="btn btn-secondary me-4" onClick={clickCancel}>
                                        {_TC("button.cancel")}
                                    </button>
                                    <FormButton
                                        type="submit"
                                        className="btn btn-primary me-3"
                                        variant="primary"
                                        label={_TC("button.save")}
                                        isProcessing={isLoading}>
                                        {_TC("button.save")}
                                    </FormButton>
                                </div>
                            </>
                        ) : (
                            <></>
                        )}
                    </Form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default FormSender;
